import { CompartmentCard } from "@/src/components/cards";
import { DayPicker } from "@/src/components/datePicker";
import { ListConstructor } from "@/src/components/fetchableLists";
import {
  CardType,
  FieldAnswer,
  FolderItem,
  Patient,
  PatientItemStatus,
  Reference
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId } from "@/src/utils/utils";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { useEffect, useState } from "react";
import { AnswersTimeline } from "./answersTimeline";

export function AnswersTimelineCompartment({
  color,
  title = "Fiche",
  additionalHtml,
  buttonTitle,
  onButtonClick,
  referenceIds,
  patient,
  parent,
  initialStatus = "finished",
}: {
  color?: CardType;
  title?: string | null | undefined;
  buttonTitle?: string | null | undefined;
  additionalHtml?: React.ReactNode;
  onButtonClick?: () => void;
  referenceIds: (string | null | undefined)[];
  patient: Patient;
  parent: FolderItem;
  initialStatus?: PatientItemStatus;
}) {
  const [reload, setReload] = useState(0);
  const [references, setReferences] = useState<Reference[] | null | undefined>(
    null
  );
  const [start, setStart] = useState(moment().format("YYYY-MM-DD"));
  const [end, setEnd] = useState(moment().add(1, "day").format("YYYY-MM-DD"));
  let [searchKey, setSearchKey] = useState("");
  let { data, isLoading, isError, error } = useQuery({
    queryKey: [
      "answersTimeline",
      searchKey,
      JSON.stringify(references),
      start,
      reload,
      getItemId(patient),
      getItemId(parent),
      JSON.stringify(referenceIds),
    ],
    queryFn: () =>
      apiFetch(
        "refAnswers",
        "loadRefAnswersAndReferences",
        {
          patientId: getItemId(patient),
          referenceIds: referenceIds.filter((id) => id != null),
        },
        "Erreur lors du chargement des tâches"
      ),
  });

  useEffect(() => {
    loadReferences();
  }, []);

  async function loadReferences() {
    const loadedReferences = await apiFetch("references", "loadMany", {
      referenceIds: referenceIds.filter((id) => id != null) as string[],
      userId: null,
    });
    console.log("loadedReferences", loadedReferences);
    setReferences(loadedReferences);
  }

  let child = (
    <div>
      <div className="c3 mc1 center mbottom10">
        <div></div>
        <DayPicker
          value={start}
          onChange={async (newValue) => {
            setStart(moment(newValue).format("YYYY-MM-DD"));
            setEnd(moment(newValue).add(1, "day").format("YYYY-MM-DD"));
          }}
        ></DayPicker>
        <div></div>
      </div>

      <div
        className="fade"
        key={`calendarTreatment${start}${end}${reload}${JSON.stringify(
          references
        )}${getItemId(patient)}${getItemId(parent)}`}
      >
        <AnswersTimeline
          references={references || []}
          answers={
            data?.refAnswers
              .flatMap((refAnswer) => refAnswer.fieldAnswers)
              .filter((answer) => answer != null) as FieldAnswer[]
          }
          start={start}
          end={end}
          patient={patient}
          parent={parent}
          initialStatus={initialStatus}
          onChange={() => {
            setReload(reload + 1);
          }}
        ></AnswersTimeline>
      </div>
    </div>
  );

  return (
    <CompartmentCard
      title={title}
      color={color || "green"}
      buttonTitle={buttonTitle || undefined}
      onClick={onButtonClick}
    >
      {additionalHtml}
      <ListConstructor
        isLoading={isLoading}
        isError={isError}
        error={error}
        data={references || []}
        emptyChild={child}
      >
        {child}
      </ListConstructor>
    </CompartmentCard>
  );
}
